import { isDevelopment } from '../environment/get-environment';

/**
 * Display a console.warn() message only in a development environment
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (...args: any) => {
  if (isDevelopment(document.location)) {
    /* eslint-disable no-console */
    console.warn(...args);
  }
};
